import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FinanceQuotesComponent } from './finance-quotes.component';
import { FinanceQuotesSummaryComponent } from './finance-quotes-summary/finance-quotes-summary.component';

const routes: Routes = [
  {
    path: 'financequotes',
    component: FinanceQuotesComponent,
    data: {
      breadcrumb: 'Finance Quotes',
    },
    children: [
      {
        path: 'summary/:id/:cartName',
        component: FinanceQuotesSummaryComponent,
        data: {
          breadcrumb: 'cartName',
        }
      }]
  },
  {
    path: 'financing',
    redirectTo: '/financequotes',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FinanceQuotesRoutingModule { }
